/**
 * Descriptores de los campos del formulario.
 *
 * Una sola lista gobierna tres cosas que antes estaban escritas por separado
 * y podian desincronizarse: el render, la validacion y el payload. Agregar un
 * campo de logistica es agregar una entrada aqui.
 */

export const TIPO_TEXTO = "text";
export const TIPO_NUMERO = "number";
export const TIPO_FECHA = "date";
export const TIPO_HORA = "time";
export const TIPO_SELECT = "select";
// Select en el que se escribe para filtrar: para listas largas.
export const TIPO_BUSCABLE = "buscable";

/** Campo comun a los dos tipos de solicitud. */
export const CAMPO_MATERIA = {
  name: "id_materia",
  label: "Seleccione Materia",
  tipo: TIPO_SELECT,
  catalogo: "materias",
};

/**
 * Reserva del espacio fisico. Se muestran y validan como bloque: ver
 * puedeVerLogistica en model/permisos.js.
 */
/**
 * La fecha del prestamo. Es el mismo campo para los dos casos, porque viaja
 * en el mismo lugar de la solicitud: el docente reserva un dia y el
 * estudiante solo propone uno.
 */
export const CAMPO_FECHA = {
  name: "fecha_prestamo",
  label: "Fecha de Prestamo",
  tipo: TIPO_FECHA,
};

/** Como lo ve el estudiante en ARIA: una propuesta, no una reserva. */
export const CAMPO_FECHA_PROPUESTA = {
  ...CAMPO_FECHA,
  label: "Fecha en la que te queda bien",
};

export const CAMPOS_LOGISTICA = [
  CAMPO_FECHA,
  {
    name: "celular",
    label: "Numero de Celular",
    tipo: TIPO_NUMERO,
    minimoCaracteres: 10,
    mensajeInvalido: "El numero de celular ingresado no es valido",
  },
  {
    name: "id_bloque",
    label: "Seleccione Bloque",
    tipo: TIPO_BUSCABLE,
    catalogo: "bloques",
  },
  {
    name: "id_salon",
    label: "Seleccione Salon",
    tipo: TIPO_BUSCABLE,
    catalogo: "salones",
  },
  { name: "hora_entrega", label: "Hora de Inicio", tipo: TIPO_HORA },
  { name: "hora_retiro", label: "Hora de Fin", tipo: TIPO_HORA },
];

export const NOMBRES_LOGISTICA = CAMPOS_LOGISTICA.map(({ name }) => name);

/** Estado inicial derivado de los descriptores: nunca se escribe a mano. */
export const VALORES_INICIALES = [
  CAMPO_MATERIA.name,
  ...NOMBRES_LOGISTICA,
].reduce((acumulado, name) => ({ ...acumulado, [name]: "" }), {});

// Los campos de hora llegan del backend como "19:40:00" y el input los
// espera como "19:40".
const soloHoraYMinuto = (valor) => (valor ? `${valor}`.slice(0, 5) : "");

/**
 * Valores con los que abre el formulario al editar una solicitud.
 *
 * La materia no esta aqui: el select trabaja con el id de SICUC, que no se
 * guarda en la solicitud, asi que el formulario la reconoce despues por su
 * codigo y su grupo.
 */
export const valoresDesdeSolicitud = (solicitud) => ({
  ...VALORES_INICIALES,
  fecha_prestamo: solicitud.fecha_prestamo ?? "",
  celular: solicitud.celular ?? "",
  id_bloque: solicitud.bloque?.id ?? "",
  id_salon: solicitud.salon?.id ?? "",
  hora_entrega: soloHoraYMinuto(solicitud.hora_inicio),
  hora_retiro: soloHoraYMinuto(solicitud.hora_fin),
});
